module.exports = __webpack_public_path__ + "media/15min.81a1a70c.mp4";